export * from './outline';
export * from './roof-box';
export * from './roof-vent'
export * from './square-vent';
export * from './square-box';
export * from './helipad';

export * from './foundation-type-1';
export * from './foundation-type-2';
export * from './foundation-type-3';

export * from './window-type-1';
export * from './window-type-2';
export * from './window-type-3';
export * from './window-type-4';
export * from './window-type-5';
export * from './window-type-6';
export * from './window-type-7';
export * from './window-type-8';
export * from './window-type-9';


export * from './shadow-type-1';
export * from './shadow-type-2';
export * from './shadow-type-3';
export * from './shadow-type-4';
export * from './shadow-type-5';

export * from './wall-type-1';
export * from './wall-type-2';
export * from './wall-type-3';
export * from './wall-type-4';
export * from './wall-type-5';
export * from './wall-type-6';
export * from './wall-type-7';
export * from './wall-type-8';
export * from './wall-type-9';


import { RoofBoxComponent } from './roof-box';
import { RoofVentComponent } from './roof-vent';
import { SquareBoxComponent } from './square-box';
import { HelipadComponent } from './helipad';


import { SquareVentComponent } from './square-vent';
import { OutlineComponent } from './outline';

import { FoundationType1Component } from './foundation-type-1';
import { FoundationType2Component } from './foundation-type-2';
import { FoundationType3Component } from './foundation-type-3';

import { WindowType1Component } from './window-type-1';
import { WindowType2Component } from './window-type-2';
import { WindowType3Component } from './window-type-3';
import { WindowType4Component } from './window-type-4';
import { WindowType5Component } from './window-type-5';
import { WindowType6Component } from './window-type-6';
import { WindowType7Component } from './window-type-7';
import { WindowType8Component } from './window-type-8';
import { WindowType9Component } from './window-type-9';

import { ShadowType1Component } from './shadow-type-1';
import { ShadowType2Component } from './shadow-type-2';
import { ShadowType3Component } from './shadow-type-3';
import { ShadowType4Component } from './shadow-type-4';
import { ShadowType5Component } from './shadow-type-5';

import { WallType1Component } from './wall-type-1';
import { WallType2Component } from './wall-type-2';
import { WallType3Component } from './wall-type-3';
import { WallType9Component } from './wall-type-9';
import { WallType8Component } from './wall-type-8';
import { WallType7Component } from './wall-type-7';
import { WallType6Component } from './wall-type-6';
import { WallType5Component } from './wall-type-5';
import { WallType4Component } from './wall-type-4';



export const BuildingAtoms = [
    WindowType1Component,
    WindowType2Component,
    WindowType3Component,
    WindowType4Component,
    WindowType4Component,
    WindowType5Component,
    WindowType6Component,
    WindowType7Component,
    WindowType8Component,
    WindowType9Component,
    OutlineComponent,
    RoofBoxComponent,
    RoofVentComponent,
    SquareVentComponent,
    SquareBoxComponent,
    HelipadComponent,
    FoundationType1Component,
    FoundationType2Component,
    FoundationType3Component,
    ShadowType1Component,
    ShadowType2Component,
    ShadowType3Component,
    ShadowType4Component,
    ShadowType5Component,
    WallType1Component,
    WallType2Component,
    WallType3Component,
    WallType4Component,
    WallType5Component,
    WallType6Component,
    WallType7Component,
    WallType8Component,
    WallType9Component
]